import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

export const NavMenu = ({ navbarTitle, logoSrc, logoHref, logoAlt, logoDimensions }) => {
    const location = useLocation();
    return (
      <header>
        <nav className="navbar sticky-top navbar-expand-lg py-3 custom-nav-bar">
          <div data-testid="navbar" className="container-fluid">
            <a href={ logoHref } className="navbar-brand">
              <img data-testid="image-logo" src={ logoSrc } alt={ logoAlt } width={ logoDimensions.width } height={ logoDimensions.height } />
            </a>
            <div className="mx-auto">
              <h3 className="navbar-text"> { navbarTitle } </h3>
            </div>
            { location.pathname !== "/" &&
              <div className="navbar-logout">
                  <a className="logout-btn" href="/">
                    <p>Log out </p>
                    <i className="bi bi-box-arrow-right logout-menu-icon" />
                  </a>
              </div>
            }
          </div>
        </nav>
      </header>
    );
};

NavMenu.propTypes = {
  /* 
    title used in the center of the navbar 
  */ 
  navbarTitle: PropTypes.string.isRequired,
  /* 
    supplier logo path of the navbar 
  */ 
  logoSrc: PropTypes.string.isRequired,
  /* 
    alt if the logo is missing in navbar 
  */ 
  logoAlt: PropTypes.string,
  /* 
    supplier logo dimensions of the navbar 
  */ 
  logoDimensions: PropTypes.object.isRequired,
}

NavMenu.defaultProps = {
  /*
   default value if title is not given
  */
  navbarTitle: '',
  /*
   default value if logoSrc is not given
  */
  logoSrc: '/images/navabar/logo-placeholder.jpg',
  /*
   default value if logoDimensions is not given
  */
  logoDimensions: {
    height: '40px',
    width: '50px'
  }
}
